import { action, computed, observable } from 'mobx';
import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { DeviceEntry, createDeviceEntries } from 'ui/history/device_entry/device_entry_logic';
import { HostMap, HistoryFilter } from 'services/pangolin/types';

export class DeviceInputStore {
  search: SearchInputStore;
  @observable.shallow entries: DeviceEntry[];

  constructor(filter: HistoryFilter, hosts: HostMap) {
    this.search = new SearchInputStore();
    this.entries = createDeviceEntries(filter, hosts);
  }

  @action.bound
  commitEntry(entry: DeviceEntry): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: DeviceEntry): void {
    const finder = ((e: DeviceEntry) => e.host.id === entry.host.id);
    const index = this.entries.findIndex(finder);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @computed get hostIDs(): string[] {
    return this.entries.map((entry) => entry.host.id);
  }
}
